import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const PaymentConfirmation = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        fill="none"
        viewBox="0 0 32 32"
        ref={forwardedRef}
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="5.58202"
          y="12.9917"
          width="18.6709"
          height="13.1481"
          rx="1.3"
          fill="#99E538"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
        <path
          d="M20.1304 22.172C20.1304 22.9233 19.5213 23.5324 18.7699 23.5324C18.0186 23.5324 17.4095 22.9233 17.4095 22.172C17.4095 21.4206 18.0186 20.8115 18.7699 20.8115C19.5213 20.8115 20.1304 21.4206 20.1304 22.172Z"
          fill="#2B2F38"
        />
        <path
          d="M22.2454 22.172C22.2454 22.9233 21.6363 23.5324 20.8849 23.5324C20.1336 23.5324 19.5245 22.9233 19.5245 22.172C19.5245 21.4206 20.1336 20.8115 20.8849 20.8115C21.6363 20.8115 22.2454 21.4206 22.2454 22.172Z"
          fill="#2B2F38"
        />
        <path
          d="M8.48535 22.172H14.6144"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="5.92596" y="15.9148" width="17.8146" height="3.26092" fill="#2B2F38" />
        <circle cx="21.3292" cy="11.4591" r="8.65242" fill="#04AF00" stroke="#2B2F38" strokeWidth="1.4" />
        <path
          d="M20.0167 12.9817L18.6418 11.5687C18.158 11.0713 17.363 11.0589 16.8638 11.5409C16.362 12.0254 16.3494 12.8255 16.8358 13.3256L18.9462 15.4955C19.7099 16.2808 20.9916 16.2095 21.6636 15.3445L25.9925 9.77266C26.4024 9.24511 26.3677 8.49785 25.9108 8.01048C25.3419 7.4036 24.366 7.44617 23.8521 8.10029L20.0167 12.9817Z"
          fill="white"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default PaymentConfirmation
